import type {ReactElement} from 'react';
import React from 'react';
import {BaseItemSepiaOption} from '@Components/poster-editor/components/poster-editing-side-panel/components/base-item-sepia-option';
import {useSingleActivePosterItemId} from '@Hooks/poster-editor/useSingleActivePosterItemId';
import {useGetKeyFromEffectsActiveItem} from '@Hooks/poster-editor/useGetKeyFromEffectsOfActiveItem';

export function ItemSepiaOption(): ReactElement<any> {
  const activeItemId = useSingleActivePosterItemId() ?? '';
  const activeItem = activeItemId ? window.posterEditor?.whiteboard?.getItemForId(activeItemId) : undefined;
  const activeItemSepia = useGetKeyFromEffectsActiveItem('sepia');
  if (!activeItem || (activeItem && !('effects' in activeItem)) || activeItemSepia === undefined) {
    throw new Error(`Item doesn't have effects property`);
  }

  const onToggleOption = (): void => {
    void activeItem.updateFromObject({
      effects: {
        sepia: !activeItemSepia,
      },
    });
  };

  return <BaseItemSepiaOption isChecked={activeItemSepia} onToggleOption={onToggleOption} />;
}
